module.exports = __webpack_public_path__ + "img/6-3.5b76ff3d.png";